<template>
  <withTopNav
    :leftText="
      configInfo.useCustomName === 'Y'
        ? configInfo.customName
        : configInfo.defaultName || ` Baú`
    "
    class="text-13"
    fixed
  >
    <div class="pt-4 relative">
      <ShareLink :title="$t('Activities.treasurebox.InviteLink')" textType="treasurebox" />
    </div>
    <div class="flex flex-col px-4 mt-6">
      <div class="text-[16px] font-[500]">{{ $t('Activities.treasurebox.QuickShare') }}</div>
      <ShareMedia />
    </div>
    <Image :src="line" alt="" class="w-full h-[1px] mt-6" />
    <div class="px-4 mt-6">
      <div class="bg-[#2C7952]/70 text-white text-[15px] pl-3 py-3 rounded-t-lg">
        {{ $t('Activities.treasurebox.UserEffectiveConditions') }}
      </div>
      <div
        class="bg-[#2C7952]/40 text-[13px] font-[500] text-white mt-[2px] flex items-center justify-between py-3 px-2.5"
      >
        <span>{{ $t('Activities.treasurebox.AccumulatedDeposits') }}</span>
        <div>
          <span class="text-[#0BCF33] mr-1 text-[16px]">
            ≥{{ formatter().format(condition.requireDeposit || 0) }}
          </span>
          <span class="text-white/65 text-[10px]">R$</span>
        </div>
      </div>
      <div
        :class="[
          'bg-[#2C7952]/20 text-[13px] font-[500] text-white/85 mt-[2px] flex items-center justify-between py-3 px-2.5',
          { 'rounded-b-lg': !configInfo.smsVerified },
        ]"
      >
        <span>{{ $t('Activities.treasurebox.GameBets') }}</span>
        <div>
          <span class="text-[#0BCF33] mr-1 text-[16px]">
            ≥{{ formatter().format(condition.requireBet || 0) }}
          </span>
          <span class="text-white/85 text-[10px]">R$</span>
        </div>
      </div>
      <!-- <div
        v-if="!configInfo.smsVerified"
        class="bg-[#2C7952]/40 text-[13px] font-[500] text-white/85 mt-[2px] flex items-center justify-between py-3 px-2.5 rounded-b-lg"
      >
        <span>Verificação número de celular</span>
        <div>
          <img :src="icon_secure" alt="" class="w-6" />
        </div>
      </div> -->
    </div>

    <div class="px-4 mt-6">
      <div
        class="text-white py-3 px-4 text-left text-[16px] rounded-t-lg bg-[#2C7952]/70 flex items-center justify-between"
      >
        <div class="flex items-center">
          <img :src="icon_Subordenada" alt="" class="w-6 h-6 mr-3" />
          {{ $t('Activities.treasurebox.Subordinate') }}
        </div>
        <div class="flex items-center">
          <span class="mr-1 text-[13px] text-white/85">{{ $t('Activities.treasurebox.Effective') }}</span>
          <van-switch
            v-model="enable"
            active-color="#0BCF33"
            inactive-color="#97B0A2"
            :style="{
              '--van-switch-width': '36px',
              '--van-switch-height': '18px',
              '--van-switch-node-size': '14px',
              '--van-switch-node-transform': 'translateX(4px)',
            }"
          />
        </div>
      </div>
      <DataTable
        class="mt-0.5"
        :columns="columns"
        :bodyBgColor="['var(--even-bg-color)', 'var(--odd-bg-color)']"
        :data="tableData"
      />
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
import DataTable from "@a/components/DataTable/index.vue";
import withTopNav from "@/layouts/withTopNav.vue";
import ShareLink from "@a/components/ShareLink/index.vue";
import ShareMedia from "@a/components/ShareMedia/index.vue";
import line from "./../images/line.png";
// import icon_secure from "./../images/icon_secure.png";
import icon_Subordenada from "./../images/icon_Subordenada.png";
import awarded_icon from "./../images/awarded_icon.png";
import unachieved_icon from "./../images/unachieved_icon.png";
import { useRoute } from "vue-router";
import { useUserInfo } from "@/store";
import {
  configDetailById,
  configDetailByIdWithoutAuth,
  queryTreatureboxInvitationsList,
  queryTreatureboxCondition,
} from "@/api/treasurebox";
import { formatter } from "@/utils";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const route = useRoute();
const configInfo = ref<any>({});
const tableData = ref<any>([]);
const enable = ref(false);
const condition = ref<any>({});
const activityId = route.query.activityId;

const columns = [
  {
    title: t('Activities.treasurebox.Name'),
    key: "loginName",
    colClass: "!flex-[1.6]",
    headClass: "!bg-[#2C7952]/40 ",
    render: (item: any) => (
      <div class="flex items-center justify-start pl-4">
        <div class="flex flex-col">
          <span class="text-[13px] font-[500] text-white/85">{item.inviteeName}</span>
          <span class="text-[11px] text-white/45">ID: {item.inviteeId}</span>
        </div>
        <img
          v-if="item.status === 1"
          src={item.status === "Awarded" ? awarded_icon : unachieved_icon}
          alt=""
          class="wh-[22px_22px] ml-3"
        />
      </div>
    ),
  },
  {
    title: t('Activities.treasurebox.Deposit'),
    headClass: "!bg-[#2C7952]/40 ",
    key: "rechargeAmt",
    render: (item) => (
      <span class="text-[11px] text-white/75 flex items-center justify-center  h-full">
        {formatter().format(item.actualDeposit)} /{" "}
        {formatter().format(item.requireDeposit)}
      </span>
    ),
  },
  {
    title: t('Activities.treasurebox.Bets'),
    headClass: "!bg-[#2C7952]/40  ",
    key: "betAmt",
    render: (item) => (
      <span class="text-[11px] text-white/75 flex items-center justify-center   h-full">
        {formatter().format(item.actualBet)} / {formatter().format(item.requireBet)}
      </span>
    ),
  },
];
// 查询宝箱活动配置
const getConfigDetail = async () => {
  const fn = useUserInfo().isLoggedin ? configDetailById : configDetailByIdWithoutAuth;
  let { code, data } = await fn({
    activityId,
  });
  if (code === 1) {
    configInfo.value = data;
  }
};

// 查询宝箱活动条件
const getTreatureboxCondition = async () => {
  const { code, data } = await queryTreatureboxCondition({
    activityId,
  });
  if (code === 1) {
    condition.value = {
      requireDeposit: data.requireDeposit,
      requireBet: data.requireBet,
    };
  }
};

// 查询宝箱活动直推用户列表
const queryxInvitationsList = async () => {
  const { code, data } = await queryTreatureboxInvitationsList({
    activityId,
    enable: enable.value,
    page: 1,
    size: 1000,
  });
  if (code === 1) {
    tableData.value = data.data;
  }
};
// 监听开关
watch(
  () => enable.value,
  () => {
    useUserInfo().isLoggedin && queryxInvitationsList();
  }
);
onMounted(() => {
  getConfigDetail();
  getTreatureboxCondition();
  useUserInfo().isLoggedin && queryxInvitationsList();
});
</script>

<style lang="scss" scoped></style>
